// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Payments_Types_PaymentAddress from "../Restaumatic.Payments.Types.PaymentAddress/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Tuple_T2.eqT2(Data_Eq.eqString)(Data_Eq.eqString)));
var eq4 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var eq5 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Payments_Types_PaymentAddress.eqPaymentAddress));
var eq6 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqBoolean));
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var actionIsSymbol = {
    reflectSymbol: function () {
        return "action";
    }
};
var fieldsIsSymbol = {
    reflectSymbol: function () {
        return "fields";
    }
};
var FormIsSymbol = {
    reflectSymbol: function () {
        return "Form";
    }
};
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var RedirectURLIsSymbol = {
    reflectSymbol: function () {
        return "RedirectURL";
    }
};
var formIsSymbol = {
    reflectSymbol: function () {
        return "form";
    }
};
var PaymentFormIsSymbol = {
    reflectSymbol: function () {
        return "PaymentForm";
    }
};
var tokenIsSymbol = {
    reflectSymbol: function () {
        return "token";
    }
};
var ApplePayRequestTokenIsSymbol = {
    reflectSymbol: function () {
        return "ApplePayRequestToken";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var P24ChannelIsSymbol = {
    reflectSymbol: function () {
        return "P24Channel";
    }
};
var StripeChannelIsSymbol = {
    reflectSymbol: function () {
        return "StripeChannel";
    }
};
var enabledIsSymbol = {
    reflectSymbol: function () {
        return "enabled";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var logoIsSymbol = {
    reflectSymbol: function () {
        return "logo";
    }
};
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var ChannelInfoIsSymbol = {
    reflectSymbol: function () {
        return "ChannelInfo";
    }
};
var addressIsSymbol = {
    reflectSymbol: function () {
        return "address";
    }
};
var applePayTokenIsSymbol = {
    reflectSymbol: function () {
        return "applePayToken";
    }
};
var blikCodeIsSymbol = {
    reflectSymbol: function () {
        return "blikCode";
    }
};
var cardTokenIsSymbol = {
    reflectSymbol: function () {
        return "cardToken";
    }
};
var channelIsSymbol = {
    reflectSymbol: function () {
        return "channel";
    }
};
var isIosAppIsSymbol = {
    reflectSymbol: function () {
        return "isIosApp";
    }
};
var PaymentRequestIsSymbol = {
    reflectSymbol: function () {
        return "PaymentRequest";
    }
};
var decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var genericEncodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(encodeWithOptionsOther);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons1 = /* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var genericDecodeArgsArgument = /* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(decodeWithOptionsOther);
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var Form = function (x) {
    return x;
};
var RedirectURL = /* #__PURE__ */ (function () {
    function RedirectURL(value0) {
        this.value0 = value0;
    };
    RedirectURL.create = function (value0) {
        return new RedirectURL(value0);
    };
    return RedirectURL;
})();
var PaymentForm = /* #__PURE__ */ (function () {
    function PaymentForm(value0) {
        this.value0 = value0;
    };
    PaymentForm.create = function (value0) {
        return new PaymentForm(value0);
    };
    return PaymentForm;
})();
var ApplePayRequestToken = /* #__PURE__ */ (function () {
    function ApplePayRequestToken(value0) {
        this.value0 = value0;
    };
    ApplePayRequestToken.create = function (value0) {
        return new ApplePayRequestToken(value0);
    };
    return ApplePayRequestToken;
})();
var P24Channel = /* #__PURE__ */ (function () {
    function P24Channel(value0) {
        this.value0 = value0;
    };
    P24Channel.create = function (value0) {
        return new P24Channel(value0);
    };
    return P24Channel;
})();
var StripeChannel = /* #__PURE__ */ (function () {
    function StripeChannel() {

    };
    StripeChannel.value = new StripeChannel();
    return StripeChannel;
})();
var ChannelInfo = function (x) {
    return x;
};
var PaymentRequest = function (x) {
    return x;
};
var toFillFormTypeStartPaymen = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypePaymentRequ = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeForm = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeChannelInfo = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeChannel = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypePaymentRequest_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeForm_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeChannelInfo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPaymentRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldForm = function (dictHasField) {
    return dictHasField;
};
var hasFieldChannelInfo = function (dictHasField) {
    return dictHasField;
};
var eqForm = {
    eq: function (x) {
        return function (y) {
            return x.action === y.action && eq1(x.fields)(y.fields);
        };
    }
};
var eq7 = /* #__PURE__ */ Data_Eq.eq(eqForm);
var eqStartPaymentResult = {
    eq: function (x) {
        return function (y) {
            if (x instanceof RedirectURL && y instanceof RedirectURL) {
                return x.value0.url === y.value0.url;
            };
            if (x instanceof PaymentForm && y instanceof PaymentForm) {
                return eq7(x.value0.form)(y.value0.form);
            };
            if (x instanceof ApplePayRequestToken && y instanceof ApplePayRequestToken) {
                return x.value0.token === y.value0.token;
            };
            return false;
        };
    }
};
var eqChannel = {
    eq: function (x) {
        return function (y) {
            if (x instanceof P24Channel && y instanceof P24Channel) {
                return x.value0 === y.value0;
            };
            if (x instanceof StripeChannel && y instanceof StripeChannel) {
                return true;
            };
            return false;
        };
    }
};
var eq8 = /* #__PURE__ */ Data_Eq.eq(eqChannel);
var eqChannelInfo = {
    eq: function (x) {
        return function (y) {
            return x.enabled === y.enabled && eq8(x.id)(y.id) && eq4(x.logo)(y.logo) && x.name === y.name;
        };
    }
};
var eqPaymentRequest = {
    eq: function (x) {
        return function (y) {
            return eq5(x.address)(y.address) && eq4(x.applePayToken)(y.applePayToken) && eq4(x.blikCode)(y.blikCode) && eq4(x.cardToken)(y.cardToken) && eq8(x.channel)(y.channel) && eq6(x.isIosApp)(y.isIosApp);
        };
    }
};
var genericStartPaymentResult = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new RedirectURL(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new PaymentForm(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new ApplePayRequestToken(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 121, column 1 - line 121, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof RedirectURL) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof PaymentForm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ApplePayRequestToken) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 121, column 1 - line 121, column 91): " + [ x.constructor.name ]);
    }
};
var genericPaymentRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericForm = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showForm = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericForm)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(actionIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(fieldsIsSymbol)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple_T2.showT2(Data_Show.showString)(Data_Show.showString))))(Data_Show.showString))))(FormIsSymbol))
};
var showStartPaymentResult = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStartPaymentResult)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(urlIsSymbol)(Data_Show.showString))))(RedirectURLIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(formIsSymbol)(showForm))))(PaymentFormIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(tokenIsSymbol)(Data_Show.showString))))(ApplePayRequestTokenIsSymbol))))
};
var unscrambleDecodeForm = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericForm)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(actionIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(fieldsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(/* #__PURE__ */ Data_Tuple_T2.udecodeT2(Unscramble.decodeString1)(Unscramble.decodeString1)))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeStartPaymentResult = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericStartPaymentResult)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(RedirectURLIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(urlIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PaymentFormIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(formIsSymbol)(unscrambleDecodeForm)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ApplePayRequestTokenIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(tokenIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericChannelInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericChannel = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new P24Channel(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return StripeChannel.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 100, column 1 - line 100, column 69): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof P24Channel) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof StripeChannel) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Payments.Types (line 100, column 1 - line 100, column 69): " + [ x.constructor.name ]);
    }
};
var showChannel = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChannel)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))(P24ChannelIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(StripeChannelIsSymbol)))
};
var showChannelInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChannelInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(enabledIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(idIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(logoIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(nameIsSymbol)(Data_Show.showString))(showMaybe))(showChannel))(Data_Show.showBoolean))))(ChannelInfoIsSymbol))
};
var showPaymentRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPaymentRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(addressIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(applePayTokenIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(blikCodeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(cardTokenIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(channelIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(isIosAppIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showBoolean)))(showChannel))(showMaybe))(showMaybe))(showMaybe))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Payments_Types_PaymentAddress.showPaymentAddress)))))(PaymentRequestIsSymbol))
};
var unscrambleDecodeChannel = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChannel)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(P24ChannelIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeInt1)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)(StripeChannelIsSymbol))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeChannelInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChannelInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(enabledIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(idIsSymbol)(unscrambleDecodeChannel)(/* #__PURE__ */ Unscramble.decodeRecordCons(logoIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodePaymentRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPaymentRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(addressIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Payments_Types_PaymentAddress.unscrambleDecodePaymentAddress))(/* #__PURE__ */ Unscramble.decodeRecordCons(applePayTokenIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(blikCodeIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(cardTokenIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(channelIsSymbol)(unscrambleDecodeChannel)(/* #__PURE__ */ Unscramble.decodeRecordCons(isIosAppIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeForm = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericForm)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(FormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(fieldsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ Data_Tuple_T2.encodeT2(genericEncodeArgsArgument)(genericEncodeArgsArgument)))))(actionIsSymbol)(encodeWithOptionsOther)))))
};
var encodeStartPaymentResult = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericStartPaymentResult)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(RedirectURLIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(urlIsSymbol)(encodeWithOptionsOther)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PaymentFormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(formIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeForm))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ApplePayRequestTokenIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(tokenIsSymbol)(encodeWithOptionsOther)))))))
};
var encodeChannel = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericChannel)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(P24ChannelIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(StripeChannelIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments)))
};
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeChannel);
var encodeChannelInfo = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericChannelInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ChannelInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(nameIsSymbol)(encodeWithOptionsOther))(logoIsSymbol)(encodeWithOptionsOther1))(idIsSymbol)(encodeWithOptionsOther2))(enabledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode))))))
};
var encodePaymentRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPaymentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PaymentRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(isIosAppIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.booleanEncode))))(channelIsSymbol)(encodeWithOptionsOther2))(cardTokenIsSymbol)(encodeWithOptionsOther1))(blikCodeIsSymbol)(encodeWithOptionsOther1))(applePayTokenIsSymbol)(encodeWithOptionsOther1))(addressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Payments_Types_PaymentAddress.encodePaymentAddress)))))))
};
var decodeForm = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericForm)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(FormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(fieldsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(/* #__PURE__ */ Data_Tuple_T2.decodeT2(genericDecodeArgsArgument)(genericDecodeArgsArgument))))())(actionIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeStartPaymentResult = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericStartPaymentResult)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(RedirectURLIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(urlIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PaymentFormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(formIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeForm))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ApplePayRequestTokenIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons1(tokenIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))))
};
var decodeChannel = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericChannel)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(P24ChannelIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(StripeChannelIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))
};
var decodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeChannel);
var decodeChannelInfo = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericChannelInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ChannelInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(nameIsSymbol)(decodeWithOptionsOther)())(logoIsSymbol)(decodeWithOptionsOther1)())(idIsSymbol)(decodeWithOptionsOther2)())(enabledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodePaymentRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPaymentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PaymentRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons1(isIosAppIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.booleanDecode)))())(channelIsSymbol)(decodeWithOptionsOther2)())(cardTokenIsSymbol)(decodeWithOptionsOther1)())(blikCodeIsSymbol)(decodeWithOptionsOther1)())(applePayTokenIsSymbol)(decodeWithOptionsOther1)())(addressIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Payments_Types_PaymentAddress.decodePaymentAddress)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    PaymentRequest,
    Form,
    ChannelInfo,
    P24Channel,
    StripeChannel,
    RedirectURL,
    PaymentForm,
    ApplePayRequestToken,
    genericPaymentRequest,
    eqPaymentRequest,
    showPaymentRequest,
    encodePaymentRequest,
    decodePaymentRequest,
    unscrambleDecodePaymentRequest,
    toFillFormTypePaymentRequ,
    hasFieldPaymentRequest,
    newtypePaymentRequest_,
    genericForm,
    eqForm,
    showForm,
    encodeForm,
    decodeForm,
    unscrambleDecodeForm,
    toFillFormTypeForm,
    hasFieldForm,
    newtypeForm_,
    genericChannelInfo,
    eqChannelInfo,
    showChannelInfo,
    encodeChannelInfo,
    decodeChannelInfo,
    unscrambleDecodeChannelInfo,
    toFillFormTypeChannelInfo,
    hasFieldChannelInfo,
    newtypeChannelInfo_,
    genericChannel,
    eqChannel,
    showChannel,
    encodeChannel,
    decodeChannel,
    unscrambleDecodeChannel,
    toFillFormTypeChannel,
    genericStartPaymentResult,
    eqStartPaymentResult,
    showStartPaymentResult,
    encodeStartPaymentResult,
    decodeStartPaymentResult,
    unscrambleDecodeStartPaymentResult,
    toFillFormTypeStartPaymen
};
